module.exports = __webpack_public_path__ + "assets/img/password.54449254.svg";